import { IconButton } from '@mui/material';
import { useState } from 'react';
import { UserInfo } from '../../../sic-lib/types/UserConfig';
import { UserAvatar } from './UserAvatar';
import { UserPopover } from './UserPopover';

interface Props {
    user: UserInfo | undefined;
}

export function UserAvatarPopoverContainer({ user }: Props) {
    //popOver functionality
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton onClick={handleClick} sx={{ p: 0 }}>
                <UserAvatar user={user} scale={2.6} />
            </IconButton>
            <UserPopover user={user} anchorEl={anchorEl} handleClose={handleClose} />
        </>
    );
}
